/*
 * @Description: 个人爆料
 * @Author: jiang.weiwei
 * @LastEditors: Please set LastEditors
 * @Date: 2017-12-06 20:13:08
 * @LastEditTime: 2022-05-26 16:28:40
 */
"use strict";
angular
    .module("explosionManageModule", [
        "explosionManageServiceModule",
        "revisedLineHeightModule",
    ])
    .controller("explosionManageCtrl", [
        "$scope",
        "$element",
        "$filter",
        "httpService",
        "explosionManageService",
        "$timeout",
        "$sce",
        "$q",
        "modalDialog",
        "trsspliceString",
        'newPageScrollPic',
        function (
            $scope,
            $element,
            $filter,
            httpService,
            explosionManageService,
            $timeout,
            $sce,
            $q,
            modalDialog,
            trsspliceString,
            newPageScrollPic
        ) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化参数
             */
            function initStatus() {
                $scope.status = {
                    inputData: "",
                    copyCurrPage: 1,
                };
                $scope.data = {
                    listData: [],
                    keywords: "", //检索的关键词
                    selectedArray: [], //选中的数据
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 12,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0,
                };
                $scope.params = {
                    startTime: "",
                    endTime: "",
                    searchWord: "",
                    searchTime: "",
                    currPage: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE,
                };
            }

            function initData() {
                requestData();
            }
            /**
             * [requestData description] 初始化列表数据
             */
            function requestData() {
                $scope.loadingPromise = httpService
                    .http("/mcnww/web/article/brokeList.do", $scope.params, "get")
                    .then(function (data) {
                        for (var i in data.data.ldata) {
                            data.data.ldata[i].imgurl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function (array) {
                                    var imgurl = [];
                                    for (var j in array) {
                                        if (array[j].filePath != null && array[j].fileType == 0) {
                                            imgurl.push(
                                                angular.globalConfig.pictureServer + array[j].filePath
                                            );
                                        }
                                        // if (array[j].fileType == 101 || array[j].fileType == 201) {
                                        //     if (!isNaN(array[j].fileName)) {
                                        //         downLoadVideo(array[j].fileName,array[j].fileType).then(function(data) {
                                        //             imgurl.push(data);
                                        //         });
                                        //     }
                                        // }
                                    }
                                    return imgurl;
                                })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                            data.data.ldata[i].videourl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function (array) {
                                    var videourl = [];
                                    for (var j in array) {
                                        if (array[j].filePath != null && array[j].fileType == 3) {
                                            videourl.push(
                                                angular.globalConfig.pictureServer + array[j].filePath
                                            );
                                        }
                                    }
                                    return videourl;
                                })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                            data.data.ldata[i].audiourl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function (array) {
                                    var audiourl = [];
                                    for (var j in array) {
                                        if (array[j].filePath != null && array[j].fileType == 2) {
                                            audiourl.push(
                                                angular.globalConfig.pictureServer + array[j].filePath
                                            );
                                        }
                                    }
                                    return audiourl;
                                })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                        }
                        /**
                         * [downLoadVideo description] 视屏展示
                         */
                        function downLoadVideo(id, libType) {
                            var deffer = $q.defer();
                            if (id == "undefined") return;
                            httpService
                                .http(
                                    "/mcnww/web/cloud/getVideoUrl.do",
                                    { id: id, libType: libType },
                                    "get"
                                )
                                .then(function (data) {
                                    if (data.data) {
                                        deffer.resolve(data.data.videoUrl);
                                    }
                                });
                            return deffer.promise;
                        }

                        $scope.data.listData = data.data.ldata;
                        $scope.data.selectedArray = [];
                        //遍历爆料列表，添加一个istrue属性
                        for (var i = 0; i < $scope.data.listData.length; i++) {
                            $scope.data.listData[i].istrue = false;
                        }
                        //获取报料列表的类型
                        for (var i = 0; i < data.data.ldata.length; i++) {
                            if (
                                data.appendixMap[String($scope.data.listData[i].id)].length == 1
                            ) {
                                $scope.data.listData[i].filetype =
                                    data.appendixMap[
                                        String($scope.data.listData[i].id)
                                    ][0].fileType;
                            } else if (
                                data.appendixMap[String($scope.data.listData[i].id)].length > 1
                            ) {
                                $scope.data.listData[i].filetype =
                                    data.appendixMap[
                                        String($scope.data.listData[i].id)
                                    ][1].fileType;
                            }
                        }
                        $scope.page = {
                            CURRPAGE: data.data.startPage,
                            PAGESIZE: data.data.pageSize,
                            ITEMCOUNT: data.data.totalResults,
                            PAGECOUNT: data.data.totalPages,
                        };
                        findPicture($scope.data.listData, data.appendixMap);
                    });
            }
            /**
             * [handleArticleContent description] 处理爆料正文
             * @param {[object]} [item] [description] 爆料信息
             * @return {[null]} [description]
             */
            $scope.handleArticleContent = function (item) {
                var contentArray = item.articleContent.split(/\n/);
                /*for (var i in contentArray) {
                        contentArray[i] = contentArray[i].replace(/ /g, "&nbsp");
                        contentArray[i] = "<p>" + contentArray[i] + "</p>";
                    }*/
                for (var i = contentArray.length - 1; i >= 0; i--) {
                    var content = contentArray[i];
                    if (content === "") {
                        contentArray.splice(i, 1);
                    } else {
                        content = content.replace(/ /g, "&nbsp;");
                        contentArray[i] = "<p>" + content + "</p>";
                    }
                }
                item.articleContentCopy = $sce.trustAsHtml(contentArray.join(""));
            };
            /**
             * [findPicture description] 图片比对
             */
            function findPicture(item, appendixMap) {
                for (var i = 0; i < item.length; i++) {
                    var items = appendixMap[item[i].id];
                    if (items.length > 0) {
                        item[i].imgUrl = items;
                    }
                }
            }
            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function () {
                $scope.params.startTime = $scope.status.startDate;
                $scope.params.endTime = $scope.status.endDate;
                requestData();
            };
            /**
             * [openpic description]打开一个图片
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.openpic = function (items) {
                newPageScrollPic.alertScrollPic(items);
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下回车也能提交]
             */
            $scope.fullTextSearch = function (ev) {
                if (
                    (angular.isDefined(ev) && ev.keyCode == 13) ||
                    angular.isUndefined(ev)
                ) {
                    $scope.params.searchWord = $scope.data.keywords;
                    requestData();
                }
            };
            /**
             * [createProduct description] -新增爆料
             * @return {[type]} [description]
             */
            $scope.createExplosion = function () {
                explosionManageService
                    .createExplosion($scope.status)
                    .then(function (data) {
                        // requestData();
                        $scope.status.copyCurrPage = 1;
                        jumpToPage();
                    });
            };

            /**
             * [selectPageNum description] 切换每页显示的条数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function () {
                $scope.params.currPage = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                $scope.status.copyCurrPage = 1;
                requestData();
            };
            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                $scope.params.currPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [jumpToPage description:跳转指定页面]
             */
            $scope.jumpToPage = function () {
                jumpToPage();
            };

            function jumpToPage() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.currPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            }
            /**
             * @description: 发布爆料
             * @param {type}
             * @return:
             */
            $scope.publish = function () {
                var params = {
                    ids: "",
                };
                multipleId($scope.data.selectedArray, params);
                modalDialog.confirmModal("发布", "确认发布选中报料吗？", function () {
                    httpService
                        .http("/mcnww/web/article/contribute.do", params, "get")
                        .then(function (data) {
                            modalDialog.success("发布成功", "info");
                            $scope.status.copyCurrPage = 1;
                            jumpToPage();
                        });
                });
            };
            /**
             * @description: 删除爆料
             * @param {type}
             * @return:
             */
            $scope.deleteList = function () {
                var params = {
                    ids: "",
                };
                multipleId($scope.data.selectedArray, params);
                modalDialog.confirmModal("删除", "确认删除选中报料吗？", function () {
                    httpService
                        .http("/mcnww/web/article/delete.do", params, "get")
                        .then(function (data) {
                            modalDialog.success("删除成功", "info");
                            $scope.status.copyCurrPage = 1;
                            jumpToPage();
                        });
                });
            };
            /**
             * @description: 编辑爆料
             * @param {type}
             * @return:
             */
            $scope.editList = function () {
                explosionManageService
                    .createExplosion($scope.status, $scope.data.selectedArray[0])
                    .then(function (data) {
                        $scope.status.copyCurrPage = 1;
                        jumpToPage();
                    });
            };
            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description] 当前数据
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                var index = $scope.data.selectedArray.indexOf(item);
                index > -1
                    ? $scope.data.selectedArray.splice(index, 1)
                    : $scope.data.selectedArray.push(item);
            };
            /**
             * [selectPanel description] 全选当前面板的稿件
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.selectPanel = function (items) {
                if (
                    $scope.data.listData.length > 0 &&
                    $scope.data.selectedArray.length == $scope.data.listData.length
                ) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [].concat($scope.data.listData);
                }
            };
            /**
             * [multipleId description;判读多个id]
             * @param  {[type]} 选中元素的集合
             */
            function multipleId(items, params) {
                if (items.length > 1) {
                    var newIds = [];
                    for (var i = 0; i < items.length; i++) {
                        newIds.push(items[i].id);
                    }
                    params.ids = newIds.join(",");
                } else {
                    params.ids = trsspliceString.spliceString(items, "id", ",");
                }
            }
        },
    ]);
